module.exports = __webpack_public_path__ + "img/mail_img.2ace8e26.svg";